import { Permissions } from "../typescript/types/data";

export const APP: Permissions = {
  PHARMA_USA: "Pharma_USA",
  BIOLOGIC_USA: "Biologic_USA",
};

export const EXPORT: Permissions = {
  PHARMA_USA: "Pharma_USA_ClinicalPipeline_TableExport",
  BIOLOGIC_USA: "Biologic_USA_ClinicalPipeline_TableExport",
};

export const PPI: Permissions = {
  PAYER_STRATEGY: "PayerStrategy",
  THERAPEUTIC_INSIGHTS_PAYER_STRATEGY: "TherapeuticInsights_PayerStrategy",
};

export const PHARMA: Permissions = {
  PHARMA_USA: "Pharma_USA",
};

export const BIOLOGIC: Permissions = {
  BIOLOGIC_USA: "Biologic_USA",
};
